import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ role, children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-stone-500" />
      </div>
    );
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  const home = { admin: "/admin", candidate: "/candidate", business: "/app" }[user.role] || "/app";
  if (role !== user.role) return <Navigate to={home} replace />;
  return children;
};
